import { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { toFormikValidationSchema } from "zod-formik-adapter";
import { z } from "zod";
import { SWAL_SETTINGS } from "../../../../utils/Constants";
import Swal from "sweetalert2";
import { updateLocationDetails, getUserInfo } from "../../services/account-setting.services";

const locationSchema = z.object({
  address: z.string().min(1, "Address is required"),
  country: z.string().min(1, "Country is required"),
  state: z.string().min(1, "State is required"),
  city: z.string().min(1, "City is required"),
  zip_code: z
    .string()
    .min(1, "Post code is required")
    .regex(/^[A-Za-z0-9][A-Za-z0-9 -]{1,9}$/, "Invalid post code"),
});

export default function EditLocationDetails() {
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");

  const [initialValues, setInitialValues] = useState({
    address: "",
    country: "",
    state: "",
    city: "",
    zip_code: "",
  });

  const handleGetLocation = () => {
    if (!navigator.geolocation) return;

    navigator.geolocation.getCurrentPosition(
      (position) => {
        setLatitude(position.coords.latitude.toFixed(6));
        setLongitude(position.coords.longitude.toFixed(6));
      },
      (error) => {
        console.error("Geolocation error:", error);
      }
    );
  };

  useEffect(() => {
    handleGetLocation();

    const fetchUserInfo = async () => {
      try {
        const res = await getUserInfo();

        if (res?.success && res?.data) {
          const user = res.data;
          setInitialValues({
            address: user.address || "",
            country: user.country || "",
            state: user.state || "",
            city: user.city || "",
            zip_code: user.zip_code || "",
          });
        }
      } catch (err) {
        console.error("Failed to fetch user info:", err);
      }
    };

    fetchUserInfo();
  }, []);

  return (
    <div className="main-content">
      <div className="customer-part">
        <div className="card-box">
          <div className="location-deatils-box">
            <h2 className="h3-headline text-center mb-5">Location Details</h2>
            <Formik
              initialValues={initialValues}
              enableReinitialize={true}
              validationSchema={toFormikValidationSchema(locationSchema)}
              onSubmit={async (values) => {
                const payload = {
                  ...values,
                  latitude,
                  longitude,
                };
      

                try {
                  const response = await updateLocationDetails(payload);
                  if (response.success) {
                    Swal.fire({
                      icon: "success",
                      text: response.message,
                      ...SWAL_SETTINGS,
                    });
                  } else {
                    Swal.fire({
                      icon: "error",
                      text: response.message,
                      ...SWAL_SETTINGS,
                    });
                  }
                } catch (error) {
                  console.log("error", error);
                  Swal.fire({
                    icon: "error",
                    text: error?.response?.data?.message || "Something went wrong",
                    ...SWAL_SETTINGS,
                  });
                }
              }}>
              {() => (
                <Form>
                  <div className="row g-3 text-start">
                    <div className="col-md-6 form-group">
                      <label className="form-label subtitle-1">Address</label>
                      <Field name="address" className="form-control" placeholder="Enter address" />
                      <div className="text-danger">
                        <ErrorMessage name="address" />
                      </div>
                    </div>

                    <div className="col-md-6 form-group">
                      <label className="form-label subtitle-1">Country</label>
                      <Field name="country" className="form-control" placeholder="Enter country" />
                      <div className="text-danger">
                        <ErrorMessage name="country" />
                      </div>
                    </div>

                    <div className="col-md-6 form-group">
                      <label className="form-label subtitle-1">State</label>
                      <Field name="state" className="form-control" placeholder="Enter state" />
                      <div className="text-danger">
                        <ErrorMessage name="state" />
                      </div>
                    </div>

                    <div className="col-md-6 form-group">
                      <label className="form-label subtitle-1">City</label>
                      <Field name="city" className="form-control" placeholder="Enter city" />
                      <div className="text-danger">
                        <ErrorMessage name="city" />
                      </div>
                    </div>

                    <div className="col-md-6 form-group">
                      <label className="form-label subtitle-1">Post code</label>
                      <Field
                        name="zip_code"
                        className="form-control"
                        placeholder="Enter post code"
                        maxLength={10}
                      />
                      <div className="text-danger">
                        <ErrorMessage name="zip_code" />
                      </div>
                    </div>

                    <div className="text-center mt-5">
                      <button type="submit" className="btn btn-oring px-5">
                        Update
                      </button>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
}
